import { Component } from '@angular/core';
import { FieldConfig } from '@smartflip/data-models';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.scss'],
  standalone: false,
})
export class CheckBoxComponent {
  field: FieldConfig;
  group: UntypedFormGroup;
}
